import { passwordComplexityRegex } from "../../../common/constants/regex";
import * as Yup from 'yup';

export interface ResetPasswordDto {
  userId: string,
  username: string,
  token: string,
  password: string,
  confirmPassword: string,
}

export const resetPasswordInit: ResetPasswordDto = { userId: '', username: '', token: '', password: '', confirmPassword: '', };

export const resetPasswordValidationSchema = Yup.object({
  username: Yup.string().email('Invalid email address')
    .required('Please enter your email.'),
  password: Yup.string()
    .notOneOf(
      [Yup.ref('currentPassword'), null],
      'New password cannot be your current password.'
    )
    .min(8, 'Password must be 12 characters or longer.')
    .max(50, 'New password must be 128 characters or less.')
    .matches(
      passwordComplexityRegex,
      'Password must contain at least 1 uppercase character, 1 lowercase character, 1 number, 1 special character and be at least 12 characters.'
    )
    .required('Please enter your new password.'),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref('password')],
      'New password and confirm password must match.'
    )
    .required('Please enter your new password.'),
})